import script from "./EmployeeFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeFormModal.vue?vue&type=style&index=0&id=7c688d8a&lang=scss"

const __exports__ = script;

export default __exports__